"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePickerPreview = require("../forms/elements/DatePickerPreview");

var _DatePickerPreview2 = _interopRequireDefault(_DatePickerPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = require("moment");
exports.default = {
  props: ["units", "user", "errors", "oldInput"],

  components: {
    DatePickerPreview: _DatePickerPreview2.default
  },

  data: function data() {
    return {
      posting: false,
      project: null,
      company: {},
      office: {},
      department: {},
      companies: this.units ? this.units.companies : [],
      offices: this.units ? this.units.offices : [],
      departments: this.units ? this.units.departments : [],
      url: "/user/" + this.user.id,
      personalNumber: null,
      password: null,
      confirmPassword: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      phoneWithCountry: null,
      userGender: "",
      dateOfBirth: null,
      validationErrors: {
        firstname: [],
        lastname: [],
        personalNumber: [],
        email: [],
        phone: [],
        company: [],
        office: [],
        department: [],
        password: [],
        confirmPassword: [],
        dateOfBirth: [],
        gender: []
      },
      currentOffices: [],
      currentDepartments: [],
      ready: false,
      isPhoneValid: false,
      isIndividual: false,
      dropdownOptions: {}
    };
  },
  mounted: function mounted() {
    // Set saved user values.
    this.company = this.setUnit("company", this.companies);
    this.office = this.setUnit("office", this.offices);
    this.department = this.setUnit("department", this.departments);
    this.project = this.user.trees[0] && this.user.trees[0].project ? this.user.trees[0].project : null;
    this.isIndividual = _.get(this.units, "is_individual", false);

    // Set values from previous request (if it was unsuccessful) or current user information.
    if (!_.isEmpty(this.oldInput)) {
      this.firstname = this.oldInput.firstname;
      this.lastname = this.oldInput.lastname;
      this.personalNumber = this.oldInput.personal_number;
      this.dateOfBirth = this.oldInput.date_of_birth;
      this.phone = this.oldInput.phone;
      this.phoneWithCountry = this.oldInput.phone;
      this.email = this.oldInput.email;
      this.password = this.oldInput.password;
      this.confirmPassword = this.oldInput.password;
      this.userGender = this.oldInput.gender || "";
      this.company = this.oldInput.company_id || "";
      this.office = this.oldInput.office_id || "";
      this.department = this.oldInput.department_id || "";
    } else {
      this.firstname = this.user.firstname;
      this.lastname = this.user.lastname;
      this.personalNumber = this.user.personal_number;
      this.dateOfBirth = this.user.date_of_birth ? this.user.date_of_birth : this.user.personal_number ? moment(this.user.personal_number.toString().substr(0, 8)).format("YYYY-MM-DD") : null;
      this.phone = this.user.phone;
      this.phoneWithCountry = this.user.phone;
      this.email = this.user.email;
      this.userGender = this.user.gender || "";
    }

    this.dropdownOptions = {
      width: "100%",
      showFlags: true,
      showDialCodeInList: true
    };
    this.ready = true;
  },


  methods: {
    setUnit: function setUnit(plural, entities) {
      var _this = this;

      if (!this.user.trees[0] || !this.user.trees[0][plural]) {
        return null;
      }
      var selected = entities.find(function (unit) {
        return unit.id === _this.user.trees[0][plural].id;
      });

      return selected ? selected : null;
    },
    validate: function validate(e) {
      var _this2 = this;

      e.preventDefault();
      Object.keys(this.validationErrors).forEach(function (key) {
        return _this2.validationErrors[key] = [];
      });

      if (this.isFormValid()) {
        this.$refs.form.submit();
      }
    },
    isFormValid: function isFormValid() {
      var _this3 = this;

      if (!this.firstname) {
        this.validationErrors.firstname.push(this.$t("sign_up.validation.firstname.empty"));
      }

      if (!this.lastname) {
        this.validationErrors.lastname.push(this.$t("sign_up.validation.lastname.empty"));
      }

      if (!this.email && !this.personalNumber) {
        this.validationErrors.email.push(this.$t("user_profile.validation.email_personal_number.empty"));
        this.validationErrors.personalNumber.push(this.$t("user_profile.validation.email_personal_number.empty"));
      } else {
        if (this.email && !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.email.toLowerCase())) {
          this.validationErrors.email.push(this.$t("sign_up.validation.email.incorrect_format"));
        }

        if (this.personalNumber && this.personalNumber.toString().length !== 12) {
          this.validationErrors.personalNumber.push(this.$t("sign_up.validation.personal_number.incorrect_length"));
        }
      }

      if (this.personalNumber && this.personalNumber.length >= 8 && !moment(this.personalNumber.substr(0, 8)).isValid()) {
        this.validationErrors.dateOfBirth.push(this.$t("sign_up.validation.date_of_birth.invalid_date"));
      }

      if (!this.personalNumber && !this.dateOfBirth) {
        this.validationErrors.dateOfBirth.push(this.$t("sign_up.validation.date_of_birth.empty"));
      }

      if (!this.phone) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.empty"));
      }

      if (!this.isPhoneValid) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.invalid"));
      }

      if (!this.userGender) {
        this.validationErrors.gender.push(this.$t("sign_up.validation.gender.empty"));
      }

      if (!this.isIndividual) {
        if (this.companies.length && !this.company) {
          this.validationErrors.company.push(this.$t("sign_up.validation.company.empty"));
        }

        if (this.currentOffices.length && !this.office) {
          this.validationErrors.office.push(this.$t("sign_up.validation.office.empty"));
        }

        if (this.currentDepartments.length && !this.department) {
          this.validationErrors.department.push(this.$t("sign_up.validation.department.empty"));
        }
      }

      // Check only if filled.
      if (this.password) {
        if (this.password !== this.confirmPassword) {
          this.validationErrors.confirmPassword.push(this.$t("sign_up.validation.password.not_match"));
        }

        if (this.password.length < 8) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.short"));
        }

        // Check on uppercase existence.
        if (!(this.password.toLowerCase() != this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_uppercase"));
        }

        // Check on lowercase existence.
        if (!(this.password.toUpperCase() != this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_lowercase"));
        }

        // Check on digits existence.
        if (!/\d+/.test(this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_digit"));
        }

        // Check non-alphabetical character existence.
        if (!/\W+/.test(this.password)) {
          this.validationErrors.password.push(this.$t("sign_up.validation.password.no_non_alphabetical"));
        }
      }

      return Object.keys(this.validationErrors).reduce(function (accumulator, key) {
        return accumulator && !_this3.validationErrors[key].length;
      }, true);
    },
    validatePhone: function validatePhone(phone) {
      this.isPhoneValid = phone.isValid;
    },
    changeFirstname: function changeFirstname(firstname) {
      this.firstname = firstname;
    },
    changeLastname: function changeLastname(lastname) {
      this.lastname = lastname;
    },
    changeEmail: function changeEmail(email) {
      this.email = email;
    },
    changePhone: function changePhone(number, details) {
      this.phoneWithCountry = details.number;
    },
    changeGender: function changeGender(gender) {
      this.userGender = gender;
    },
    changePersonalNumber: function changePersonalNumber(personalNumber) {
      this.personalNumber = personalNumber;
    },
    changePassword: function changePassword(password) {
      this.password = password;
    },
    changeConfirmPassword: function changeConfirmPassword(confirmPassword) {
      this.confirmPassword = confirmPassword;
    },
    changeCompany: function changeCompany(company) {
      this.changeOffice("");
      this.company = company;
    },
    changeOffice: function changeOffice(office) {
      this.changeDepartment("");
      this.office = office;
    },
    changeDepartment: function changeDepartment(department) {
      this.department = department;
    },
    changeDateOfBirth: function changeDateOfBirth(date) {
      this.dateOfBirth = moment(date).format("YYYY-MM-DD");
    }
  },

  computed: {
    filteredOffices: function filteredOffices() {
      var _this4 = this;

      this.currentDepartments = [];
      var currentOffices = _(this.offices).filter(function (office) {
        return office.company_id === _.get(_this4.company, "id");
      }).value();
      this.currentOffices = currentOffices;

      return _.isEmpty(currentOffices) ? null : currentOffices;
    },
    filteredDepartments: function filteredDepartments() {
      var _this5 = this;

      var currentDepartments = _(this.departments).filter(function (department) {
        return department.office_id === _.get(_this5.office, "id");
      }).value();
      this.currentDepartments = currentDepartments;

      return _.isEmpty(currentDepartments) ? null : currentDepartments;
    },
    gender: function gender() {
      return [{ name: this.$t("user_profile.placeholders.gender_male"), id: "male" }, {
        name: this.$t("user_profile.placeholders.gender_female"),
        id: "female"
      }];
    }
  },

  watch: {
    personalNumber: function personalNumber() {
      if (this.personalNumber && this.personalNumber.length >= 8 && moment(this.personalNumber.substr(0, 8)).isValid()) {
        this.dateOfBirth = moment(this.personalNumber.substr(0, 8)).format("YYYY-MM-DD");
      } else if (!this.personalNumber || this.personalNumber.length < 8) {
        this.dateOfBirth = null;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/EditProfileMenu.vue
// module id = dluL
// module chunks = 0 1